import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { readIntent } from './features/checkout/intent';
import { ThemeProvider } from '@mui/material/styles';
import AppTheme from './libs/mui/AppTheme';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@shared/queries';
import routes from './routes';
import ImpersonationSwitcher from '@shared/components/dev/ImpersonationSwitcher';

export const router = createBrowserRouter(routes);

const App = () => {
  const { error } = useAuth0();
  useEffect(() => {
    if (error && readIntent()) void router.navigate('/checkout', { replace: true });
  }, [error]);
  return (
    <ThemeProvider theme={AppTheme}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        {import.meta.env.DEV && <ImpersonationSwitcher />}
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
